import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AdminV3AutomationsPage } from '@apps/web/features/admin_v3_automations';

export const Route = createFileRoute('/_app/admin/agent/v3-automations')({
    head: () => ({
        meta: [{ title: 'Automations | Internal Admin Agent' }],
    }),
    validateSearch: z.object({
        automation: z.uuid().optional().catch(undefined),
    }),
    component: AutomationsRoute,
});

function AutomationsRoute() {
    const { automation } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
        <AdminV3AutomationsPage
            automationFilter={automation ?? null}
            onAutomationFilterChange={(automationId) =>
                void navigate({
                    search:
                        automationId === null
                            ? {}
                            : { automation: automationId },
                    replace: true,
                })
            }
        />
    );
}
